// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._154id439{top:-14px}
._154inicn{top:-18px}
._1bsb12am{width:50px}
._1ltv1q9q{left:-11px}
._1ltv1vh9{left:-9pt}
._4t3i7vkz{height:1pc}
._kqswstnw{position:absolute}
._t9ec2k2r{transform:scale(.8)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlassian/search-ai/dist/esm/common/ui/ai-answer-loading/dot-animation-loader/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,SAAS;AACpB,WAAW,SAAS;AACpB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,SAAS;AACpB,WAAW,UAAU;AACrB,WAAW,iBAAiB;AAC5B,WAAW,mBAAmB","sourcesContent":["._154id439{top:-14px}\n._154inicn{top:-18px}\n._1bsb12am{width:50px}\n._1ltv1q9q{left:-11px}\n._1ltv1vh9{left:-9pt}\n._4t3i7vkz{height:1pc}\n._kqswstnw{position:absolute}\n._t9ec2k2r{transform:scale(.8)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
